import React from 'react';
import CONSTANTS from './constants.js'
import {connect} from 'react-redux'

class DisplayLabel extends React.Component{
    constructor(props){
        super(props);
    }
    
    render(){
        return(
            <div className='displayLabel outerWrapper borderBox'>
                <h1 id="timer-label">{this.props.displayString}</h1>
            </div>
        )
    }
}

export default connect(CONSTANTS.MAP_STATE_TO_PROPS)(DisplayLabel);